module.exports = __webpack_public_path__ + "img/4.07ebce86.png";